import actionCreatorFactory from 'typescript-fsa';
import { reducerWithInitialState } from 'typescript-fsa-reducers';
//const authentication = require('react-azure-adb2c').default;
//import { Dispatch } from 'redux';


import { call, put, takeEvery, select } from 'redux-saga/effects';
import * as CashTeller_api from '../Api/CashTeller';



///types
const moment = require('moment')

export interface State {

    cash_tellers_list: any
    cash_tellers_contentslist: any
    cash_teller_monthly: any,
    cash_teller_nowmonthly: any,
    update: any,
    insert: any,
    delete: any,

}
const initialState: State = {

    cash_tellers_list: [],
    cash_tellers_contentslist: [],
    cash_teller_monthly: [],
    cash_teller_nowmonthly: [],
    update: [],
    insert: [],
    delete: []

}



///action 
const actionCreator = actionCreatorFactory();


export const get_cash_tellers_list = actionCreator('GET_CASH_TELLERS_LIST');
export const get_cash_tellers_list_success = actionCreator('GET_CASH_TELLERS_LIST_SUCCESS');

export const get_cash_tellers_contentslist = actionCreator('GET_CASH_TELLERS_CONTENTSLIST');
export const get_cash_tellers_contentslist_success = actionCreator('GET_CASH_TELLERS_CONTENTSLIST_SUCCESS');

export const cash_tellers_insert = actionCreator('CASH_TELLERS_INSERT');
export const cash_tellers_insert_success = actionCreator('CASH_TELLERS_INSERT_SUCCESS');

export const cash_tellers_update = actionCreator('CASH_TELLERS_UPDATE');
export const cash_tellers_update_success = actionCreator('CASH_TELLERS_UPDATE_SUCCESS');

export const cash_tellers_delete = actionCreator('CASH_TELLERS_DELETE');
export const cash_tellers_delete_success = actionCreator('CASH_TELLERS_DELETE_SUCCESS');

export const get_cash_teller_monthly = actionCreator('GET_CASH_TELLER_MONTHLY');
export const get_cash_teller_monthly_success = actionCreator('GET_CASH_TELLER_MONTHLY_SUCCESS');


export const get_cash_teller_nowmonthly = actionCreator('GET_CASH_TELLER_NOWMONTHLY');
export const get_cash_teller_nowmonthly_success = actionCreator('GET_CASH_TELLER_NOWMONTHLY_SUCCESS');


export const cash_tellers_monthly_insert = actionCreator('CASH_TELLERS_MONTHLY_INSERT');
export const cash_tellers_monthly_delete = actionCreator('CASH_TELLERS_MONTHLY_DELETE');



export const CashTellerReducer = reducerWithInitialState(initialState)
    .case(get_cash_tellers_list_success, (state, payload) => ({ ...state, cash_tellers_list: payload }))
    .case(get_cash_tellers_contentslist_success, (state, payload) => ({ ...state, cash_tellers_contentslist: payload }))
    .case(get_cash_teller_monthly_success, (state, payload) => ({ ...state, cash_teller_monthly: payload }))
    .case(cash_tellers_update_success, (state, payload) => ({ ...state, update: payload }))
    .case(cash_tellers_insert_success, (state, payload) => ({ ...state, insert: payload }))
    .case(cash_tellers_delete_success, (state, payload) => ({ ...state, delete: payload }))
    .case(get_cash_teller_nowmonthly_success, (state, payload) => ({ ...state, cash_teller_nowmonthly: payload }))


// 「LOGIN_REQUEST」アクションが呼ばれるのを待つ呼ばれたhandleRequestを実行
export const CashTellerSaga = [

    takeEvery('GET_CASH_TELLERS_LIST', handle_get_cash_tellers_list),
    takeEvery('GET_CASH_TELLERS_CONTENTSLIST', handle_get_cash_tellers_contentslist),
    takeEvery('CASH_TELLERS_INSERT', handle_cash_tellers_insert),
    takeEvery('GET_CASH_TELLER_MONTHLY', handle_cash_teller_monthly),
    takeEvery('CASH_TELLERS_UPDATE', handle_cash_tellers_update),
    takeEvery('CASH_TELLERS_DELETE', handle_cash_tellers_delete),
    takeEvery('CASH_TELLERS_MONTHLY_INSERT', handle_cash_tellers_monthlyinsert),
    takeEvery('CASH_TELLERS_MONTHLY_DELETE', handle_cash_tellers_monthlydelete),

    takeEvery('GET_CASH_TELLER_NOWMONTHLY', handle_cash_teller_nowmonthly),


];




function* handle_get_cash_tellers_list(action: any) {

    const { payload, error } = yield call(CashTeller_api.list, action.payload);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        yield put(get_cash_tellers_list_success(payload))
    } else {
        // alert(error)
    }
}

function* handle_get_cash_tellers_contentslist(action: any) {

    const { payload, error } = yield call(CashTeller_api.contentslist, action.payload);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        yield put(get_cash_tellers_contentslist_success(payload))
    } else {
        // alert(error)
    }
}

function* handle_cash_tellers_insert(action: any) {

    const { payload, error } = yield call(CashTeller_api.insert, action.payload);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        yield put(cash_tellers_insert_success(payload))

    } else {

        console.log(error)
    }
}

function* handle_cash_tellers_update(action: any) {

    const { payload, error } = yield call(CashTeller_api.update, action.payload);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        yield put(cash_tellers_update_success(payload))

    } else {

        console.log(error)
    }
}


function* handle_cash_tellers_delete(action: any) {

    const { payload, error } = yield call(CashTeller_api.del, action.payload);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        yield put(cash_tellers_delete_success(payload))

    } else {

        console.log(error)
    }
}


function* handle_cash_teller_monthly(action: any) {

    const { payload, error } = yield call(CashTeller_api.getmonthly, action.payload);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        yield put(get_cash_teller_monthly_success(payload))
    } else {

    }
}

function* handle_cash_teller_nowmonthly(action: any) {

    const { payload, error } = yield call(CashTeller_api.nowmonthly, action.payload);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        yield put(get_cash_teller_nowmonthly_success(payload))
    } else {

    }
}

function* handle_cash_tellers_monthlyinsert(action: any) {

    const { payload, error } = yield call(CashTeller_api.monthly_insert, action.payload);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
    } else {

    }
}

function* handle_cash_tellers_monthlydelete(action: any) {

    const { payload, error } = yield call(CashTeller_api.monthly_delete, action.payload);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
    } else {

    }
}
